"use client";
import { MapPin, Clock, Mail, Phone } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function ContactInfo() {
  const { t } = useTranslation("info");

  const contactItems = [
    {
      icon: <MapPin className="w-5 h-5 text-primary" />,
      title: t("contactInfo.addressTitle"),
      lines: [t("contactInfo.addressLine1"), t("contactInfo.addressLine2")],
    },
    {
      icon: <Clock className="w-5 h-5 text-primary" />,
      title: t("contactInfo.hoursTitle"),
      lines: [t("contactInfo.hoursLine1"), t("contactInfo.hoursLine2")],
    },
    {
      icon: <Mail className="w-5 h-5 text-primary" />,
      title: t("contactInfo.emailTitle"),
      lines: [t("contactInfo.emailLine1")],
    },
    {
      icon: <Phone className="w-5 h-5 text-primary" />,
      title: t("contactInfo.phoneTitle"),
      lines: [t("contactInfo.phoneLine1")],
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-white rounded-lg shadow-sm p-6 border border-gray-100"
    >
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900">
          {t("contactInfo.titlePart1")}{" "}
          <span className="text-primary">{t("contactInfo.titlePart2")}</span>
        </h2>
        <p className="text-gray-600">{t("contactInfo.slogan")}</p>
      </div>

      <div className="space-y-6">
        {contactItems.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: index * 0.1 }}
            className="flex gap-4 items-start"
          >
            <div className="p-2 bg-primary/10 rounded-full">{item.icon}</div>
            <div>
              <h3 className="font-medium text-gray-900">{item.title}</h3>
              {item.lines.map((line, i) => (
                <div key={i}>
                  {item.title === t("contactInfo.emailTitle") ? (
                    <a href={`mailto:${line}`}>{line}</a>
                  ) : item.title === t("contactInfo.phoneTitle") ? (
                    <a href={`tel:${line}`}>{line}</a>
                  ) : (
                    <p className="text-gray-600 text-sm">{line}</p>
                  )}
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
